import React from 'react';
import { Image, Checkbox } from 'react-bootstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, dateFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { ReminderService } from '../services/reminder.service';
import { ReminderLog } from '../models/reminderlog';

interface IState {
  remindersLog: ReminderLog[];
  status: string;
  columns: any;
}

export class RemindersLogPage extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      remindersLog: new Array<ReminderLog>(),      
      status: "",
      columns: [{
        dataField: 'id',
        text: 'ID',
        headerStyle: () => {
          return { width: '5%' };
        },
        sort: true
      },
      {
        dataField: 'reminder.image',
        text: 'Slika',
        formatter: (cellContent, row) => {
          return (
            <Image src={row.reminder.image} />
          );
        }
      },
      {
        dataField: 'reminder.name',
        text: 'Naziv podsjetnika',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'reminderLogTime',
        text: 'Vrijeme izvršavanja',
        sort: true,
        filter: dateFilter({
          withoutEmptyComparatorOption: true,
        }),
        formatter: (cellContent, row) => {
          return (
            new Intl.DateTimeFormat("hr-HR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            }).format(new Date(cellContent))
          );
        }
      }, 
      {
        dataField: 'isReminderCompleted',
        text: 'Podsjetnik izvršen?',
        headerStyle: () => {
          return { width: '9%' };
        },
        sort: true,
        formatter: (cellContent, row) => {
          return (
            <Checkbox checked={row.isReminderCompleted} disabled />
          );
        }
      }]
    };
  }

  componentDidMount() {

    let id = this.props.match.params.id ? this.props.match.params.id : 0;

    if (id !== 0) {

        ReminderService.getUserRemindersLog(id)
          .then(
            response => {
              this.setState({
                remindersLog: response
              });
            },
            error => {
              this.setState({
                status: error.message
              });
            }
          );
      }
  }
  
  render() {
    return (
      <div>
        <h1 className="page-title">Dnevnik ispunjavanja podsjetnika</h1>
        <div className="row">
          <div className="col-md-12">
            { this.state.status &&
              <div className={'alert alert-danger'}>{this.state.status}</div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <BootstrapTable 
              striped
              hover
              keyField='id' 
              data={ this.state.remindersLog } 
              columns={ this.state.columns }
              filter={ filterFactory() } 
              pagination={ paginationFactory() }/>
          </div>
        </div>
        <button
            className="button icon-left"
            onClick={this.props.history.goBack}>
            Povratak
        </button>
      </div>
    );
  }
}